import {
  addCollection,
  updateCollection,
  addInviteRecrd
} from '@/api/index'
import {
  mapGetters
} from 'vuex'
import {
  inviteOrIM
} from '@/utils/function.js'
export const eventMixin = {
  data() {
    return {
      identity: ''
    }

  },
  computed: {
    ...mapGetters(['subjectType','language'])
  },
  methods: {
    // 收藏
    collectEvent(data, index, moduleName=null) {
      if (!this.isLoginFn()) return
      if (!this.todoPrission()) return
      window.PC.$RangersEventCollect(data.collectionSubjectId, data, moduleName)
      if (data.deleted) {
        //取消收藏
        updateCollection(data).then(res => {
          if (res.data && res.data.code === 1000) {
            // this.$notify.success(this.$t('finds.collectionF'))
            if (typeof index == 'function') {
              index(false)
            } else {
              this.updateCollect(false, index)
            }
          }
        })
      } else {
        //添加收藏
        addCollection(data).then(res => {
          if (res.data && res.data.code === 1000) {
            // this.$notify.success(this.$t('finds.collectionS'))
            if (typeof index == 'function') {
              index(true)
            } else {
              this.updateCollect(true, index)
            }
          }
        })
      }
    },
    // 邀约 客商
    inviteEvent(params, index) {
      console.log(params, index)
      if (!this.isLoginFn()) return
      if (!this.todoPrission()) return
      addInviteRecrd(params).then(res => {
        if (res.data && res.data.code === 1000) {
          inviteOrIM({
            acceptId: params.id || params.userId,
            acceptSubjectType: 'VISITOR',
            url: location.href,
            interateType: this.language == 'en' ? 'INTERATE_INVITE_EN' : 'INTERATE_INVITE_CN',
            language: this.language
          })
          this.$notify.success(this.$t('finds.inviteSuccess'));
          if (typeof index == 'function') {
            index(true)
          } else {
            this.updateInvite(true, index)
          }
        }
      })
    },
    // 直播详情
    liveEvent(id) {
      if (!this.todoPrission()) return
      this.pageDetail({id}, 'live')
    }
  }
}